import React, { PropTypes } from 'react'
import moment from 'moment';
import Avatar from 'components/Avatar/Avatar';
import CertificateLink from 'components/CpdLocker/CertificateLink.jsx'
import { cpdPoints } from 'components/CPDPoints';
import constants from 'constants';

const {
  CPD_STATUSES
} = constants;

const PreviousWebinarItem = ({
    webinar: {
      webinar_title,
      start_date,
      expert_name,
      doctor_type,
      work_location,
      vimeo_url,
      doctor_avatar_url,
      sponsor,
      joined,
      is_quiz_completed,
      cpd_status,
      job_code_recorded_list
    },
    webinar,
    token,
    subscriptionAction
  }) => {
  return (
    <div className="section_previous">
      <div className="section_photo">
        <Avatar size={55} name={expert_name} src={doctor_avatar_url}/>
      </div>
      <div className="section_info row">
        <div className="col l3">
          <p className="section_name">{expert_name}</p>
          <p className="section_post">
            {`${doctor_type}`}・{work_location}
          </p>
        </div>
        <div className="col l3">
          <p className="section_topic">{webinar_title}</p>
          <p className="section_previous_theme"></p>
        </div>
        <div className="col l2">
          <p className="section_date">{start_date ? moment(start_date).format('D/M/YYYY') : '-'}&nbsp;{start_date ? moment(start_date).format('h:mm a').toUpperCase() : ''}</p>
          <p className="section_time"></p>
        </div>
        <div className="col l2">
          <p className="section_logo">{sponsor && sponsor.logo_url && <img src={sponsor.logo_url} alt="logo"/>}</p>
        </div>
        <div className="col l1">
          <p className="section_previous_points">CPD Points:</p>
          <p>
            {cpdPoints(webinar)}
          </p>
        </div>
        <div className="col l1">
        {(joined || is_quiz_completed) && ( cpd_status === CPD_STATUSES.granted ) && <CertificateLink
          token={token}
          webinarId={webinar.id}
        />}
      </div>
      <div className="job_code col l1">
        {job_code_recorded_list ? (
          <div>
            <p>Job code:</p>
            <p><strong>{job_code_recorded_list}</strong></p>
          </div>
        ):null}
        </div>
      </div>
      <a href="javascript:void(0)" onClick={vimeo_url && subscriptionAction}></a>
    </div>
  )
}

PreviousWebinarItem.propTypes = {
  webinar: PropTypes.obj
}


export default PreviousWebinarItem



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/PreviousWebinars/PreviousWebinarItem.js
 **/